<div class="min-vh-100">
  <div class="d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Child Requirements For {{ hierarchy_name }}</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Manage global onboarding and quantity rules within the
              <span class="fw-bold">{{ hierarchy_name }}</span> hierarchy.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs shadow-lg d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#subentity_requirement_modal"
              @click="add_requirement"
              :disabled="assigned_children_loading || !assignable_children.length"
            >
              <i class="bi bi-plus-circle me-2"></i>
              <span>Add Requirement</span>
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div
            v-for="metric in hero_metrics"
            :key="metric.label"
            class="col-12 col-md-6 mt-2"
          >
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white" :class="`metric-icon-${metric.tone}`">
                  <i class="bi" :class="metric.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="d-flex flex-column gap-4">
      <section>
        <div class="row g-2 pt-1">
          <div v-if="loading" class="col-12">
            <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 text-secondary text-xs">
          Loading child requirements...
              </div>
        </div>
      </div>

          <div v-else-if="load_error" class="col-12">
            <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 text-danger text-xs">
          {{ load_error }}
              </div>
        </div>
      </div>

          <div v-else-if="!requirement_cards.length" class="col-12">
            <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 text-secondary text-xs">
          No child requirements found yet.
              </div>
        </div>
      </div>

          <div
        v-else
            class="col-12"
      >
          </div>

          <div
          v-for="requirement in requirement_cards"
          :key="requirement.id"
            class="col-12 col-md-6 col-lg-4 col-xl-3"
          >
            <article class="card h-100 border-purple border-opacity-50 shadow rounded-4">
              <div class="card-body p-2 d-flex flex-column h-100">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
              <div
                class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
              >
                <i class="bi" :class="requirement.icon"></i>
              </div>
              </div>
                  <div class="d-flex align-items-center gap-2">
                    <span
                      class="badge rounded-pill text-uppercase fw-bold px-2 py-1 text-xxs lh-1"
                      :class="requirement.is_active ? 'text-bg-success' : 'text-bg-secondary'"
                    >
                      {{ requirement.is_active ? 'Active' : 'Inactive' }}
                    </span>

                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 text-dark text-decoration-none"
                      :disabled="removing_requirement_id === String(requirement.id)"
                      @click="remove_requirement(requirement)"
                    >
                      <span
                        v-if="removing_requirement_id === String(requirement.id)"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        v-else
                        class="bi bi-x-lg"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
            </div>

                <div class="mb-2 mt-2 ms-1">
                    <p class="text-xs fw-bold text-dark mb-0">{{ requirement.name }}</p>

                  <div class="text-uppercase fw-bold text-secondary mb-1 text-xxs mt-1">
                    Quantity Constraints
                  </div>
              <div class="small fw-semibold text-dark">
                {{ requirement.quantity_constraint }}
              </div>
            </div>

                <div class="mb-2 flex-grow-1 ms-2">
                  <div class="text-uppercase fw-bold text-secondary mb-1 text-xxs">
                    Onboarding Mode
                  </div>
              <div class="bg-light rounded-3 d-inline-flex align-items-center gap-1 px-2 py-1 text-dark text-xs">
                <i class="bi" :class="requirement.onboarding_icon"></i>
                <span>{{ requirement.onboarding_label }}</span>
              </div>
            </div>

                <div class="border-top pt-2 mt-auto ms-2">
                    <div class="d-flex flex-column gap-1 text-xxs">
                    <div class="text-secondary text-uppercase fw-semibold">Required for completion : <span class="fw-bold text-dark">{{ requirement.is_required ? 'Yes' : 'No' }}</span></div>
                    <div class="text-secondary text-uppercase fw-semibold">Display order : <span class="fw-bold text-dark">{{ requirement.display_order }}</span> </div>
                    <div class="text-secondary text-uppercase fw-semibold">Created : <span class="fw-bold text-dark">{{ requirement.date_created || 'Not available' }}</span></div>
              </div>
            </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="subentity_requirement_modal"
      tabindex="-1"
      aria-labelledby="subentity_requirement_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xxs mb-0" id="subentity_requirement_modal_label">Create Child Requirement</p>
              <div class="small text-white-50 mt-1">
                Parent: {{ hierarchy_name }}
              </div>
            </div>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              :disabled="creating_requirement"
            ></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Select Child Entity</label>
              <select
                v-model="selected_requirement_child_id"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm text-x"
                :disabled="assigned_children_loading || creating_requirement || !assignable_children.length"
                @change="on_requirement_child_change"
              >
                <option value="">
                  {{ assigned_children_loading ? 'Loading child entities...' : 'Select a child entity' }}
                </option>
                <option
                  v-for="item in assignable_children"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <div v-if="!assigned_children_loading && !assignable_children.length" class="small text-secondary mt-2">
                No child entities are assigned to this parent yet.
              </div>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Display Name</label>
              <input
                v-model.trim="requirement_form.display_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Enter requirement display name"
              />
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Minimum Count</label>
                <input
                  v-model.number="requirement_form.min_count"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Maximum Count</label>
                <input
                  v-model.trim="requirement_form.max_count"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  placeholder="Leave blank for no maximum"
                />
                <div class="form-text text-xxs">Leave blank for no maximum.</div>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Onboarding Mode</label>
                <select
                  v-model="requirement_form.onboarding_mode"
                  class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm text-x"
                >
                  <option value="manual">Manual</option>
                  <option value="self_service">Self Service</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Display Order</label>
                <input
                  v-model.number="requirement_form.display_order"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                />
              </div>
            </div>

            <div class="form-check form-switch mt-3">
              <input
                id="subentity-requirement-required"
                v-model="requirement_form.is_required_for_completion"
                class="form-check-input"
                type="checkbox"
              />
              <label class="form-check-label small" for="subentity-requirement-required">
                Required for completion
              </label>
            </div>
          </div>

          <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1 text-white"
              :disabled="creating_requirement || assigned_children_loading || !assignable_children.length || !selected_requirement_child_id"
              @click="create_requirement"
            >
              {{ creating_requirement ? 'Creating...' : 'Create Requirement' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
